import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AESService {

  constructor() {}

  public encrypt(value : string) : string{
    return CryptoJS.AES.encrypt(value, environment.encryptionKey.trim()).toString();
  }

  public decrypt(textToDecrypt : string){
    return CryptoJS.AES.decrypt(textToDecrypt, environment.encryptionKey.trim()).toString(CryptoJS.enc.Utf8);
  }



  public decryptProgressToken(textToDecrypt: string): string {
    const rawKey = environment.encryptionKey.trim();
    const paddedKey = rawKey.length >= 24
      ? rawKey.substring(0, 24)
      : 'X'.repeat(24 - rawKey.length) + rawKey;
    const key = CryptoJS.enc.Utf8.parse(paddedKey);
    const iv = CryptoJS.lib.WordArray.create([0, 0, 0, 0], 16);
    const ciphertext = CryptoJS.enc.Base64.parse(textToDecrypt);
    const decrypted = CryptoJS.AES.decrypt(
      CryptoJS.lib.CipherParams.create({ ciphertext }),
      key,
      { mode: CryptoJS.mode.CFB, padding: CryptoJS.pad.NoPadding, iv }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  public criptogrfaSenha(senha: string): string{
    return CryptoJS.HmacSHA256.encrypt(senha, environment.encryptionKey.trim()).toString();
  }
}
